import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cadastrar-frequencia-aluno-unidade',
  templateUrl: './cadastrar-frequencia-aluno-unidade.component.html',
  styleUrls: ['./cadastrar-frequencia-aluno-unidade.component.css']
})
export class CadastrarFrequenciaAlunoUnidadeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
